/* Resource-type visuals shared by list/detail pages (port of the design
   prototype's R_TYPES in manage.jsx). Tints map to the rec-tint-* classes. */
const RESOURCE_TYPES = {
  SCPU: { icon: "solar_power", tint: "rec-tint-amber" },
  STORAGE: { icon: "battery_charging_full", tint: "rec-tint-teal" },
  EV: { icon: "ev_station", tint: "rec-tint-info" },
  EWH: { icon: "water_heater", tint: "rec-tint-green" },
  HP: { icon: "heat_pump", tint: "rec-tint-info" },
  IC: { icon: "bolt", tint: "rec-tint-teal" },
  IU: { icon: "home", tint: "rec-tint-teal" },
};

export function resourceVisual(type) {
  return RESOURCE_TYPES[type] || { icon: "category", tint: "rec-tint-teal" };
}

export default RESOURCE_TYPES;
